module.exports = __webpack_public_path__ + "img/TYS-2-2.cbc61bd8.jpg";